import { GeneralFullPageRoutes } from "./generalFullPageRoutes";

export const FullPageRoutes = [...GeneralFullPageRoutes];
